"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UIBetaButton = _interopRequireDefault(require("UIComponents/button/UIBetaButton/UIBetaButton"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIOptConstants = require("ui-addon-opt/constants/UIOptConstants");

var OptLoading = function OptLoading() {
  return _react.default.createElement(_UIBetaButton.default, {
    icon: "none",
    style: _UIOptConstants.POSITIONING
  }, _react.default.createElement(_UILoadingSpinner.default, {
    use: "on-dark"
  }));
};

var _default = OptLoading;
exports.default = _default;
module.exports = exports.default;